<zuper-drawer
    class="address-drawer"
    [fixed]="true"
    [mode]= "'over'"
    [name]="'allAddress'"
    [position]="'right'"
    [transparentOverlay]="false"
    [hideOnClickOutside]="false"
    (openedChanged)="addressDrawerOpen($event)">
        <div class="h-full w-full">
            <div class="p-2 border-b border-gray-300 flex justify-between">
                <div class="primary-font font-bold text-lg text-gray-900 flex items-center pl-2">
                    {{addressOptions?.drawerTitle | translate}}
                </div>
                <div>
                    <button type="button" mat-icon-button (click)="toggleDrawer('allAddress')">
                        <em class="ti ti-x text-gray-900 text-xl"></em>
                    </button>
                </div>
            </div>
            <ng-container *ngIf="!utilityService.isEmptyOrUndefined(addressOptions?.uid)">
                <div class="border-b border-gray-200 bg-white rounded-md">
                    <nav class="-mb-px flex" aria-label="Tabs">
                        <a *ngFor="let tab of addressTabs" rel="{{tab.rel}}_container"
                            class="whitespace-nowrap flex justify-center items-center py-4 px-1 border-b-2 font-medium text-lg primary-font cursor-pointer w-1/{{addressTabs.length}} mt-1"
                            (click)="changeViewMode(tab.dataKey)" [ngClass]="setTabClasses(tab.dataKey)">
                            <span class="truncate max-w-3/4">{{tab.displayKey | translate}}</span>
                            <div class="ml-2" *ngIf="tab.hasCount">
                                <badge [options]="getBadgeOptions(tab)" class="-ml-1 primary-font"></badge>
                            </div>
                        </a>
                    </nav>
                </div>
            </ng-container>
            <div *ngIf="selectedAddressTab === 'allAddress'" class="all-address-height overflow-y-auto zuper-scrollbar">
                <div class="w-full p-4">
                    <input
                        type="search"
                        class="block p-3 z-20 text-base text-gray-900 bg-white w-full rounded-lg border border-gray-300 searchinput" 
                        placeholder='Search ...'
                        [(ngModel)]="searchText" (ngModelChange)="onModelChange()"
                    >
                </div>
                <div class="w-full h-full overflow-y-auto" *ngIf="addressOptions?.addressList?.length > 0">
                    <div *ngFor="let address of addressOptions?.addressList;let i=index">
                        <div class="flex items-center p-4 w-full"  [ngClass]="addressOptions?.addressList?.length-1 === i ? '' : 'border-b'" *ngIf="(address?.street || address?.state)">
                            <input id="{{'address_'+ i}}" type="radio"  (change)="valueChanged($event,address)" [checked]="ischecked(address)" class="h-4 w-4 border-gray-300 text-indigo-600">
                            <label for="{{'address_'+ i}}" class="ml-3 block text-base font-medium w-full text-gray-700 cursor-pointer">
                                <div class="pb-3 px-4">
                                    <p *ngIf="address?.title?.length > 0" class="font-bold leading-5 truncate text-lg text-gray-600 ml-1 mb-0 flex justify-between items-center h-12 mt-0.5">
                                        <span *ngIf="address?.title?.length > 0">{{address?.title}}</span>
                                    </p>
                                    <p *ngIf="address?.label?.length > 0" class="font-bold leading-5 truncate text-base text-gray-600 ml-1 mb-0 flex justify-between items-center h-12 mt-0.5">
                                        <span *ngIf="address?.label?.length > 0">{{address?.label}}</span>
                                    </p>
                                    <div class="flex px-1 text-gray-500 font-medium">
                                        <div class="flex justify-between w-full">
                                            <div>
                                                <p *ngIf="address?.first_name"
                                                    class="text-base mb-2">
                                                    {{address?.first_name}}
                                                    {{address?.last_name || ''}} 
                                                    </p>
                                                <p *ngIf="address?.street" class="text-base mb-2">
                                                    {{address?.street}}</p>
                                                <p *ngIf="address?.landmark" class="text-base mb-2">
                                                    {{address?.landmark}}</p>    
                                                <p *ngIf="address?.city" class="text-base mb-2">
                                                    {{address?.city}}</p>
                                                <p *ngIf="address?.state" class="text-base mb-2">
                                                    {{address?.state}}
                                                    {{address?.zip_code ? '- ' +
                                                    address?.zip_code : '' }}</p>
                                                <p *ngIf="address?.country" class="text-base">
                                                    {{address?.country}}</p>
                                            </div>
                                            <div class="flex justify-end">
                                                <span class="cursor-pointer flex intems-center justify-center rounded-full h-8 w-8 p-2 hover:bg-gray-200"
                                                    *ngIf="address?.geo_cordinates"
                                                    [matTooltip]="('text.view_on_map' | translate)"
                                                    matTooltipPosition="left">
                                                    <a class="ml-auto text-primary-500 cursor-pointer" target="_blank"
                                                        href="{{utilityService.getMapsCoordinatesUrl(address?.geo_cordinates[0], address?.geo_cordinates[1])}}">
                                                        <em class="ti ti-external-link text-xl"></em>
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                        
                    </div>
                </div>
                <div class="flex w-full h-full items-center justify-center" *ngIf="addressOptions?.addressList.length === 0">
                    <div class="bg-card w-100 h-50 shadow-sm inline-flex flex-col items-center justify-center">
                        <div class="rounded-full w-20 h-20 shadow-sm inline-flex items-center justify-center bg-gray-100">
                        <img class="w-12" src="assets/images/svgs/no_results_found_common_icon.svg"
                            alt="No Data found">
                        </div>
                        <h4 class="font-medium mt-4 text-secondary mx-5 text-center">{{'address.data.not_found.placeholder' | translate}}</h4>
                    </div>
                </div>                            
            </div>
            <div *ngIf="['newAddress'].includes(selectedAddressTab)" class="h-full">
                <div class="container-height zuper-scrollbar overflow-y-auto px-4">
                    <div class="flex">
                        <div class="rounded-full px-4 py-2 ml-2 mt-4 border border-gray-300 text-base primary-font cursor-pointer" [ngClass]="type.selected ? 'bg-primary text-white':'text-secondary'" (click)="updateSelectedLabel(type)" *ngFor="let type of addressType">
                            {{type.label}}
                            <em class="ti ti-check ml-2 text-white font-bold" *ngIf="type.selected"></em>
                        </div>
                    </div>
                    <form autocomplete="off" [formGroup]="addressForm" ngNativeValidate autocomplete="off">
                        <div class="flex flex-col w-full h-full">
                            <div class="px-2 py-3 w-full" *ngIf="isAddressType === 'Others'">
                                <mat-form-field [hideRequiredMarker]="true" class="h-15 field-full-width" appearance="fill" [floatLabel]="'always'">
                                    <mat-label class="text-base text-gray-500 font-medium">{{'create.customer.label.text' | translate}}
                                    </mat-label>
                                    <input id="label" type="text" matInput formControlName="label"
                                        placeholder="{{'create.customer.label.text' | translate}}">
                                </mat-form-field>
                            </div>
                            <div class="flex flex-wrap w-full">
                                <div class="w-full">
                                    <contact-info [fields]="addressFields" [addressFormGroupName]="contactAddressForm">
                                    </contact-info>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="absolute inset-x-0 bottom-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                <div class="flex justify-end space-x-4 ml-auto">
                    <button  type="button" mat-stroked-button (click)="toggleDrawer('allAddress')"
                        class="px-6 items-center py-2 btn-small border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text'
                        | translate}}</button>
                    <button type="button" (click)="sendAddress()"
                        class="bg-primary primary-font text-base btn-small px-6 flex items-center py-2 border shadow-sm text-white font-medium rounded-md focus:outline-none">
                        {{addressOptions?.submitButtonDisplayKey | translate}}
                    </button>
                </div>
            </div>
        </div>
</zuper-drawer>